export function removeNumberOrRange(array: { label: string, value: string }[], rangeOrNumber: string) {
    if (!rangeOrNumber || !Array.isArray(array)) {
        return array
    }

    const cleaned = rangeOrNumber.trim()

    if (/^\d+$/.test(cleaned)) {
        const target = parseInt(cleaned, 10)
        return array.filter(item => Number(item.value) !== target)
    }

    const match = cleaned.match(/^(\d+)\s*-\s*(\d+)$/)
    if (match) {
        const start = parseInt(match[1], 10)
        const end = parseInt(match[2], 10)

        if (start > end) throw new Error("Invalid range: start must be less than end")

        return array.filter((item) => Number(item.value) < start || Number(item.value) > end)
    }

    throw new Error("Must be a single number or a range")
}